(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-custom"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq-question').forEach((btn) => {
  btn.addEventListener('click', () => {
    const parent = btn.parentElement;
    parent.classList.toggle('active');
    btn.querySelector('.faq-icon').textContent = parent.classList.contains('active') ? '-' : '+';
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const searchBox = document.querySelector('.search-box');
  const searchBtn = document.querySelector('.search-btn');

  searchBtn?.addEventListener('click', () => {
    if (searchBox?.value.trim()) {
      alert('Searching for: ' + searchBox.value);
    }
  });

  searchBox?.addEventListener('keypress', function (e) {
    if (e.key === 'Enter' && searchBox.value.trim()) {
      alert('Searching for: ' + searchBox.value);
    }
  });

  document.querySelector('.cart-icon')?.addEventListener('click', () => {
    const cartDrawerEl = document.querySelector('cart-drawer');
    cartDrawerEl.open(document.querySelector('.cart-icon'));
  });

  document.querySelector('.cart-icon-mobile')?.addEventListener('click', () => {
    const cartDrawerEl = document.querySelector('cart-drawer');
    cartDrawerEl.open(document.querySelector('.cart-icon-mobile'));
  });
  // document.querySelector(".user-icon")?.addEventListener("click", () => {
  //   alert("User profile clicked!");
  // });

  } catch(e) { console.error(e); }
})();
})();
